import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-313ba4c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OkTable" }
const _hoisted_2 = {
  key: 0,
  scope: "col"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, i) => {
          return (_openBlock(), _createElementBlock("th", {
            scope: "col",
            key: `TableHeadCol-${i}`
          }, _toDisplayString(column.name), 1))
        }), 128)),
        (_ctx.$slots.actions)
          ? (_openBlock(), _createElementBlock("th", _hoisted_2))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, i) => {
        return (_openBlock(), _createElementBlock("tr", {
          class: _normalizeClass({ 'cursor-pointer': _ctx.clickableRow }),
          key: `TableBodyRow-${i}`,
          onClick: ($event: any) => (_ctx.onRowClick(row))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, j) => {
            return (_openBlock(), _createElementBlock("td", {
              key: `TableBodyRowTd-${i}-${j}`
            }, [
              (_ctx.$slots.td)
                ? _renderSlot(_ctx.$slots, "td", {
                    row: row,
                    column: column,
                    key: `${i}-${j}`
                  }, undefined, true)
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(row[column.key]), 1)
                  ], 64))
            ]))
          }), 128)),
          (_ctx.$slots.actions)
            ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
                _renderSlot(_ctx.$slots, "actions", { row: row }, undefined, true)
              ]))
            : _createCommentVNode("", true)
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}